import { Component, inject } from '@angular/core';
import { AuthSessionService } from '../../auth-session.service';

@Component({
  imports: [],
  selector: 'app-dining',
  styleUrl: './dining.scss',
  templateUrl: './dining.html',
})
export class Dining {
  readonly version = inject(AuthSessionService).paxVersion;
}
